import RuejaiClubVoucherPackageListPage from "./pages/RuejaiClubVoucherPackageListPage";
import RuejaiClubVoucherPackageCreatePage from "./pages/RuejaiClubVoucherPackageCreatePage";
import RuejaiClubVoucherPackageDetailPage from "./pages/RuejaiClubVoucherPackageDetailPage";

export const ruejaiClubVoucherPackageRoutes = (prefix = "voucher-packages") => [
  {
    name: "RuejaiClubVoucherPackageCreatePage",
    path: `${prefix}/create`,
    component: RuejaiClubVoucherPackageCreatePage
  },
  {
    name: "RuejaiClubVoucherPackageDetailPage",
    path: `${prefix}/:id`,
    component: RuejaiClubVoucherPackageDetailPage
  },
  {
    name: "RuejaiClubVoucherPackageListPage",
    path: prefix,
    component: RuejaiClubVoucherPackageListPage
  }
];
